import React from 'react';
import { motion } from 'framer-motion';
import { Info } from 'lucide-react';
export function Disclaimer() {
  return <section className="py-16 px-6 bg-brand-bg" data-id="element-306">
      <div className="max-w-[800px] mx-auto" data-id="element-307">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-yellow-500/5 border border-yellow-500/30 rounded-2xl p-6 md:p-8" data-id="element-308">
          <div className="flex items-start gap-4" data-id="element-309">
            <div className="shrink-0 mt-1" data-id="element-310">
              <div className="w-10 h-10 rounded-full bg-yellow-500/10 border border-yellow-500/30 flex items-center justify-center" data-id="element-311">
                <Info className="w-5 h-5 text-yellow-500" data-id="element-312" />
              </div>
            </div>
            <div data-id="element-313">
              <h3 className="text-lg font-bold text-yellow-500 mb-3 tracking-wide" data-id="element-314">
                Importante — Lee antes de comprar
              </h3>
              <p className="text-sm md:text-base text-white/80 leading-relaxed" data-id="element-315">
                BIO-X 90 es un material educativo sobre hábitos, rendimiento y
                bienestar. No sustituye diagnóstico, tratamiento ni consejo
                médico profesional. Consulta con un profesional de salud antes
                de modificar alimentación, suplementación, sueño, ayuno o
                actividad física, especialmente si tienes condiciones médicas,
                tomas medicación o estás bajo tratamiento.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}